import { render, staticRenderFns } from "./GathetTaskDig.vue?vue&type=template&id=a036eddc&scoped=true"
import script from "./GathetTaskDig.vue?vue&type=script&lang=js"
export * from "./GathetTaskDig.vue?vue&type=script&lang=js"
import style0 from "./GathetTaskDig.vue?vue&type=style&index=0&id=a036eddc&prod&lang=scss&scoped=true"
import style1 from "./GathetTaskDig.vue?vue&type=style&index=1&id=a036eddc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a036eddc",
  null
  
)

export default component.exports